<template>
  <div>
    <!-- <page-header :title="title" :container-class="containerClass" /> -->
    <div class="page-section">
      <div :class="containerClass">
        <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-24pt" style="white-space: nowrap">
          <h2 class="mb-0">Events</h2>
          <div class="w-auto ml-sm-auto mb-sm-0 justify-content-end">
            <!-- Events Filter -->
          </div>
        </div>

        <page-separator
          :title="
            !isLoading ? `showing ${totalEvents ? `${pageFromCount}-${pageToCount}` : 0} of ${totalEvents} events` : ''
          "
        />

        <div class="page-section d-flex justify-content-center" v-if="!events.length && !isLoading">
          <div class="card card-block card-stretch card-height col-md-8">
            <div class="card-body text-center">
              <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
              <h4>No Open Events</h4>

              <p class="text-muted">
                There aren't any open events available right now. Please check again later for upcoming events.
              </p>
            </div>
          </div>
        </div>

        <b-skeleton-wrapper :loading="isLoading" v-else>
          <template #loading>
            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-6" v-for="item in [1, 2, 3]" :key="item">
                <div class="card card-sm card--elevated p-relative">
                  <span class="js-image">
                    <b-skeleton-img width="100%" class="pb-0 mb-0"></b-skeleton-img>
                  </span>

                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex">
                        <a class="card-title" href="#" @click.prevent><b-skeleton width="70%"></b-skeleton></a>
                        <small class="text-50 font-weight-bold mb-4pt"><b-skeleton width="50%"></b-skeleton></small>
                      </div>

                      <div class="media ml-sm-auto align-items-center">
                        <div class="media-left mr-2 avatar-group">
                          <div
                            class="avatar avatar-sm rounded-circle o-hidden"
                            style="border: 1px solid #dfe2e6;id #dfe2e6;id #dfe2e6;pxl"
                          >
                            <b-skeleton-img class="avatar-img" width="160" height="100%"></b-skeleton-img>
                          </div>
                          <div
                            class="avatar avatar-sm rounded-circle o-hidden"
                            style="border: 1px solid #dfe2e6;id #dfe2e6;id #dfe2e6;pxl"
                          >
                            <b-skeleton-img class="avatar-img" width="160" height="100%"></b-skeleton-img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="row card-group-row mb-lg-12pt home-card">
            <div class="col-lg-4 col-md-6 col-sm-6" v-for="event in events" :key="event.id">
              <div
                class="card card-sm card--elevated p-relative clickable-item"
                data-toggle="popover"
                data-trigger="click"
                @click="openEventDetails(event.id)"
              >
                <span
                  class="js-image d-flex justify-content-center clickable-item"
                  data-position="left"
                  :data-height="168"
                >
                  <img :src="event.image_url || DefaultEventImg" alt="event" class="career-card-img" />
                </span>

                <div class="card-body">
                  <div class="d-flex">
                    <a class="flex" href="#" @click.prevent>
                      <div class="card-title">
                        {{ event.title }}
                        <i class="material-icons icon-16pt ml-1 text-50" v-b-popover.hover.top="event.summary">info</i>
                      </div>
                      <small class="text-50 font-weight-bold mt-2 mb-4pt d-flex align-items-center">
                        <i class="material-icons icon-16pt mr-1">event</i> {{ formatDateTime(event.scheduled_at) }}
                      </small>
                    </a>
                    <div class="media ml-sm-auto align-items-center">
                      <div class="media-left mr-2 avatar-group">
                        <div
                          class="avatar avatar-sm"
                          v-for="mod in event.slicedMods"
                          :key="mod.id"
                          v-b-popover.hover.top
                          :title="mod.name"
                        >
                          <img :src="mod.image_url || DefaultEventImg" alt="Avatar" class="avatar-img rounded-circle" />
                        </div>
                      </div>
                      <div class="media-body" v-if="get(event.moderators, 'length', 0) > 2">
                        <a href="#" @click.prevent :id="`mod-popover-${event.id}`"
                          >+{{ event.moderators.length - 2 }} more</a
                        >
                        <moderators-list-popover
                          :moderators="event.remainingMods"
                          :target-id="event.id"
                        ></moderators-list-popover>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-skeleton-wrapper>

        <pagination
          v-if="totalEvents > events.length"
          v-model="currentPage"
          :total-rows="totalEvents"
          :per-page="perPage"
          @change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import PageHeader from '@/components/Ui/PageHeader.vue';

import Page from '@/components/Page.vue';
import { debounce, get, slice } from 'lodash';
import { mapActions } from 'vuex';
import moment from 'moment';

import DefaultEventImg from '@/assets/images/placeholders/cna_career.jpg';
import Pagination from '../../../components/Ui/Pagination.vue';
import ModeratorsListPopover from './EventModerators/ModeratorsListPopover.vue';
import PageSeparator from '@/components/Ui/PageSeparator.vue';

export default {
  extends: Page,
  name: 'EventsListing',
  components: { Pagination, ModeratorsListPopover, PageSeparator },

  data() {
    return {
      DefaultEventImg,
      title: 'Events',

      events: [],
      isLoading: true,
      perPage: 16,
      currentPage: 1,
      totalEvents: 0,
      pageFromCount: 0,
      pageToCount: 0,

      ordering: '-scheduled_at',
      searchTerm: '',
    };
  },

  computed: {
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Events', active: true },
      ];
    },
  },

  methods: {
    ...mapActions('event', ['getStudentEvents']),
    get,

    async fetchEvents(pageNum = 1, params = {}) {
      this.isLoading = true;
      document.getElementById('app').scrollIntoView();

      const response = await this.getStudentEvents({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...(this.ordering && { ordering: this.ordering }),
        ...(this.searchTerm && { search: this.searchTerm }),
        ...params,
      });

      for (const event of response.data.results) {
        event['slicedMods'] = slice(event.moderators, 0, 2);
        event['remainingMods'] = slice(event.moderators, 2);
      }
      this.events = response.data.results;
      this.currentPage = pageNum;
      this.totalEvents = response.data.count;
      this.pageFromCount = (this.currentPage - 1) * this.perPage + 1;
      this.pageToCount = this.pageFromCount + get(response.data, 'results.length', 0) - 1;
      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchEvents(pageNum);
    },

    onSearch() {
      this.debouncedSearchEvents(this);
    },

    debouncedSearchEvents: debounce((vm) => {
      vm.fetchEvents();
    }, 500),

    formatDateTime(dateTime) {
      return moment(dateTime).format('ddd, MMM DD, hh:mm A');
    },

    openEventDetails(id) {
      this.$router.push({ name: 'student-event-details', params: { id } });
    },
  },

  async mounted() {
    this.fetchEvents();
  },
};
</script>
